import { render, staticRenderFns } from "./Montos.vue?vue&type=template&id=2c81ae6b&"
import script from "./Montos.vue?vue&type=script&lang=js&"
export * from "./Montos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports